export default __webpack_public_path__ + "static/media/rentedPropIcon.4897df1b.svg";